import {useLocation} from 'react-router-dom';
import {useJobAlert} from '@tinct/web-layout';
import {useQueryClient} from "@tanstack/react-query";

type UseAudienceImportJobAlertOptions = {
  jobId: string | null | undefined;
  /** Where the job-alert widget link should send the user once the import
   *  job completes. */
  completedUrl: string;
};

export function useAudienceImportJobAlert({
  jobId,
  completedUrl,
}: UseAudienceImportJobAlertOptions) {
  const {pathname} = useLocation();
  const queryClient = useQueryClient();

  // Distinct `pendingUrl` per job so `JobAlertWidget` (which hides any job
  // whose pendingUrl matches the current pathname) still surfaces it after
  // the user navigates away via "Run in background".
  const pendingUrl = jobId ? `${pathname}#audience-import=${jobId}` : pathname;

  const {start} = useJobAlert({
    name: 'Audience import',
    pendingUrl,
    completedUrl,
    onStart: () => {
      queryClient.invalidateQueries({ queryKey: ['audiences'] });
      queryClient.invalidateQueries({ queryKey: ['audience'] });
    },
    onTerminal: (status) => {
      if (status === 'completed' || status === 'failed') {
        queryClient.invalidateQueries({ queryKey: ['audiences'] });
        queryClient.invalidateQueries({ queryKey: ['audience'] });
        return;
      }
    }
  });

  return {start};
}
